// extracted by mini-css-extract-plugin
export default {"companyRadioBtn":"companyForm_companyRadioBtn__NccZl","errorText":"companyForm_errorText__2-3A4"};